export const postLogs = async ({ axios, logs }) => {
  const { data } = await axios.post('logs', logs)

  return data
}
